import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: "month-grid",
    "data-testid": `${_ctx.testid}-custom-picker-month`
  }, [
    _createVNode(_component_v_list, { class: "month-list-items" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthLabels, (monthLabel, index) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: index + 1,
            class: _normalizeClass(["month-list-item", {
          selected: _ctx.isMonthSelected(index),
          disabled: _ctx.isDisabled(index + 1),
          current: _ctx.isCurrentMonth(index + 1),
        }]),
            disabled: _ctx.isDisabled(index + 1),
            onClick: ($event: any) => (!_ctx.isDisabled(index + 1) && _ctx.$emit('select', index + 1))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(monthLabel), 1)
            ]),
            _: 2
          }, 1032, ["class", "disabled", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}